// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__38JK_","notes":"Notes_notes__2bUIp"};